<template>
    <div>
        <!-- <div class="columns">
            <div class="column is-12 is-inline-flex is-justify-content-flex-end">
                <div class="select">
                    <select v-model="filters.skill" @change="refreshFilters">
                        <option value="">Seleccione un trámite</option>
                        <option v-for="(item, index) in skills" :key="`skill-${index}`">
                            {{ item.id }}
                        </option>
                    </select>
                </div>
                <div class="control ml-2">
                    <input type="text" class="input is-radiusless" v-model="filters.search" />
                </div>
                <button class="button is-primary is-radiusless" @click="refreshFilters">
                    <Icon family="fal" name="fa-search" />
                </button>
                <div class="select ml-2">
                    <select v-model="filters.take" @change="refreshFilters">
                        <option>10</option>
                        <option>25</option>
                        <option>50</option>
                        <option>100</option>
                    </select>
                </div>
            </div>
        </div> -->
        <div class="column is-12 has-text-right">
            <div>
                <div class="field mr-3">
                    <div class="control">
                        <label class="mr-2"
                            >Recarga en {{ reloadCountdown }} segundos</label
                        >
                        <button
                            class="button is-primary"
                            @click="reload"
                            :disabled="isLoading"
                        >
                            <Icon family="fal" name="fa-sync" />
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="column is-12 is-inline-flex" v-if="isLoading">
            <Loading />
        </div>
        <div class="column is-12 is-inline-flex" v-if="!isLoading">
            <table class="table is-striped is-hoverable is-fullwidth">
                <thead>
                    <tr>
                        <th>Cédula</th>
                        <th>Estado</th>
                        <th>Trámite</th>
                        <th>Fecha de Ingreso</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="item in items" :key="item.id">
                        <td>{{ item.userId }}</td>
                        <td>{{ parseStatus(item.status) }}</td>
                        <td>{{ item.skill }}</td>
                        <td>{{ formatDate(item.joinDate) }}</td>
                    </tr>

                    <tr v-if="totalPages === 0">
                        <td align="center" colspan="4">No hay usuarios...</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div
            class="column is-12 is-inline-flex is-justify-content-flex-end"
            v-if="totalPages > 1"
        >
            <nav class="pagination" role="navigation">
                <a
                    class="pagination-previous"
                    v-if="currentPage > 1"
                    v-on:click="prev()"
                    >Anterior</a
                >
                <a
                    class="pagination-previous"
                    v-if="currentPage < totalPages"
                    v-on:click="next()"
                    >Siguiente</a
                >

                <ul class="pagination-list">
                    <li v-if="currentPage > 2">
                        <a class="pagination-link" @click="goto(1)">1</a>
                    </li>

                    <li v-if="currentPage > 3">
                        <span class="pagination-ellipsis">&hellip;</span>
                    </li>
                    <li v-if="currentPage > 1">
                        <a
                            class="pagination-link"
                            v-on:click="goto(currentPage - 1)"
                            >{{ currentPage - 1 }}</a
                        >
                    </li>
                    <li>
                        <a
                            class="pagination-link is-current"
                            v-on:click="goto(currentPage)"
                            aria-current="page"
                            >{{ currentPage }}</a
                        >
                    </li>
                    <li v-if="totalPages > currentPage">
                        <a
                            class="pagination-link"
                            v-on:click="goto(currentPage + 1)"
                            >{{ currentPage + 1 }}</a
                        >
                    </li>
                    <li v-if="totalPages - currentPage > 2">
                        <span class="pagination-ellipsis">&hellip;</span>
                    </li>

                    <li v-if="totalPages - currentPage > 1">
                        <a
                            class="pagination-link"
                            v-on:click="goto(totalPages)"
                            >{{ this.totalPages }}</a
                        >
                    </li>
                </ul>
            </nav>
        </div>
    </div>
</template>

<script>
import { RepositoryFactory } from "@/services/api";

import moment from "moment";

import Loading from "@/components/Loading.vue";

export default {
    name: "online-users-table",
    components: {
        Loading,
    },
    props: {
        signalRSocket: {
            type: Object,
            required: true,
        },
        skills: {
            type: Array,
            default: null,
        },
    },
    data() {
        return {
            isLoading: true,

            items: [],
            currentPage: 1,
            totalPages: 0,
            filters: {
                page: 1,
                take: 10,
                search: "",
                status: "",
                skill: "",
            },

            reloadCountdown: 60,
            reloadTimer: null,
        };
    },
    mounted() {
        this.getItems();

        this.signalRSocket.on("UserJoined", this.userJoined);
        this.signalRSocket.on("UserLeaved", this.userLeaved);
    },
    beforeDestroy() {
        this.stopTimer();

        this.signalRSocket.off("UserJoined", this.userJoined);
        this.signalRSocket.off("UserLeaved", this.userLeaved);
    },
    methods: {
        restartTimer() {
            this.stopTimer();
            this.startTimer();
        },
        startTimer() {
            this.reloadTimer = setInterval(() => {
                this.reloadCountdown--;
                if (!this.isLoading && this.reloadCountdown === 0) {
                    this.reloadCountdown = 60;
                    this.getItems();
                } else if (this.reloadCountdown <= 0) {
                    this.reloadCountdown = 60;
                }
            }, 1000);
        },
        stopTimer() {
            this.reloadCountdown = 60;
            clearInterval(this.reloadTimer);
        },
        reload() {
            this.getItems();
        },
        async userJoined() {
            this.getItems();
        },
        async userLeaved() {
            this.getItems();
        },
        async getItems() {
            this.stopTimer();
            this.isLoading = true;
            try {
                let filters = this.filters;
                await RepositoryFactory.conference.cleanOnlineUsers();
                var response =
                    await RepositoryFactory.conference.getPagedOnlineUsers(
                        filters
                    );

                this.items = response.data.items;
                this.totalPages = response.data.pages;
            } catch (error) {
                window.console.log(error);
            }
            this.isLoading = false;
            this.startTimer();
        },
        refreshFilters() {
            this.currentPage = 1;
            this.filters.page = this.currentPage;
            this.getItems();
        },
        goto(page) {
            this.currentPage = page;
            this.filters.page = this.currentPage;
            this.getItems();
        },
        prev() {
            this.currentPage = this.currentPage - 1;
            this.filters.page = this.currentPage;
            this.getItems();
        },
        next() {
            this.currentPage = this.currentPage + 1;
            this.filters.page = this.currentPage;
            this.getItems();
        },
        formatDate(date) {
            return moment(date).format("DD/MM/YYYY hh:mm A");
        },
        parseStatus(status) {
            switch (status) {
                case 0:
                    return "Desconectado";
                case 1:
                    return "Esperando";
                case 2:
                    return "En llamada";
            }
            return "-";
        },
    },
};
</script>